"use client";

import { Flex, Text, type FlexProps, type TextProps } from "@chakra-ui/react";
import { useTenantCurrency } from "@/hooks";
import { UsdAmountText } from "./UsdAmountText";

interface CurrencyWithUsdLabelProps {
  amount: number;
  currency?: string;
  valueProps?: TextProps;
  centsProps?: TextProps;
  usdLabelProps?: TextProps;
  wrapperProps?: FlexProps;
  "data-testid"?: string;
}

/** Hero/summary amounts with smaller cents + currency code label - summary cards only. */
export function CurrencyWithUsdLabel({
  amount,
  currency: currencyOverride,
  valueProps,
  centsProps,
  usdLabelProps,
  wrapperProps,
  "data-testid": dataTestId,
}: CurrencyWithUsdLabelProps) {
  const tenantCurrency = useTenantCurrency();
  const currency = currencyOverride ?? tenantCurrency;

  return (
    <Flex align="baseline" gap={2} flexWrap="wrap" data-testid={dataTestId} {...wrapperProps}>
      <UsdAmountText
        amount={amount}
        currency={currency}
        textProps={{ lineHeight: "1.2", ...valueProps }}
        centsProps={centsProps}
      />
      <Text
        as="span"
        fontSize="sm"
        fontWeight="600"
        letterSpacing="0.08em"
        {...usdLabelProps}
      >
        {currency}
      </Text>
    </Flex>
  );
}
